var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0C15.198 0 0 15.198 0 34C0 52.802 15.198 68 34 68C52.802 68 68 52.802 68 34C68 15.198 52.802 0 34 0ZM51 46.206L46.206 51L34 38.794L21.794 51L17 46.206L29.206 34L17 21.794L21.794 17L34 29.206L46.206 17L51 21.794L38.794 34L51 46.206Z",
    fill: "#EC5C52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBig);
export default __webpack_public_path__ + "static/media/cancelBig.15548c3ee6305d730faf43b197e7e5f6.svg";
export { ForwardRef as ReactComponent };